import { Component } from '@angular/core';

import {NgxSpinnerComponent } from "ngx-spinner";

import { NavigationEnd, Router, RouterModule, RouterOutlet } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { VisitorService } from '../app/services/VisitTracker/visit-tracker.service';

@Component({
  selector: 'app-root',
  imports: [

    RouterModule,
    RouterOutlet,
    NgxSpinnerComponent
],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'TowardsGermany';

  constructor(
    private visitorService: VisitorService,
    private router:Router,
    private viewportScroller: ViewportScroller

  ){
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.viewportScroller.scrollToPosition([0, 0]); // Scroll to top
      }
    });
  }
  
  ngOnInit() {
    this.visitorService.trackVisit().subscribe();

  }





}
